export default __webpack_public_path__ + "book_details-page_flip.e8037938.png";